import React from 'react';
import { motion } from 'framer-motion';

function About() {
  return (
    <section id="about" className="relative py-24 bg-surface/30 border-y border-border">
      <div className="max-w-3xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '0px 0px 300px 0px' }}
          transition={{ duration: 0.4 }}
        >
          <p className="text-sm text-accent-2 font-medium mb-3 uppercase tracking-wider">About</p>
          <h2 className="font-display font-bold text-5xl md:text-6xl text-text mb-7 leading-tight">
            Hey, I'm Nate.
          </h2>

          <p className="text-text-muted text-lg leading-relaxed mb-5">
            I build software for a living — full-stack web and AI. I started Sudco Solutions because most small businesses are still running their back office by hand: chasing invoices manually, responding to reviews one by one, sending follow-ups when they happen to remember. There's a better way.
          </p>

          <p className="text-text-muted text-lg leading-relaxed mb-10">
            I build AI agents — digital workers that handle that work for you. Custom systems designed around how your business runs, not a SaaS product you have to adapt yourself to. Most clients have their first automation live within a week. The website side is still here, still $800 flat with a live demo before you pay — it's just one tool in the toolbox now, not the whole story.
          </p>

          <div className="flex flex-col gap-1 mb-10">
            <span
              className="font-script text-6xl md:text-7xl leading-none gradient-text"
              aria-label="Signed, Nate"
            >
              — Nate
            </span>
            <span className="text-xs text-text-muted tracking-wider uppercase pl-1">
              Founder · Sudco Solutions
            </span>
          </div>

          <a
            href="#contact"
            className="inline-flex items-center gap-2 bg-gradient-brand text-white px-6 py-3 rounded-full font-semibold hover:shadow-glow transition-shadow text-sm"
          >
            Start a conversation
          </a>
        </motion.div>
      </div>
    </section>
  );
}

export default About;
